@for (b of btns; track b; let i = $index) {
    <div 
        class="rounded-pill text-uppercase mb-2 d-flex align-items-center justify-content-center fsemibold p-2 border cursor-pointer f12" 
        [class.fix-width]="fixWidth" 
        [class.bg-primary]="i === defaultIdx" 
        (click)="click(i);"
    >
        {{ b.text }}
    </div>
}
